import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../utility/mainLogo.png';

// ✅ The Industry Standard: FontAwesome Icons via react-icons
import { FaInstagram, FaLinkedinIn, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section brand-section">
            <div className="footer-logo-section">
              <img src={logo} alt="TrekVerse" className="footer-logo" />
              <h3 className="footer-brand">TrekVerse</h3>
            </div>
            <p className="footer-description">
              Empowering professionals across Tech, Electronics, Management & Civil domains with
              industry-leading programs and placement opportunities.
            </p>

            {/* ✅ Upgraded FontAwesome Social Icons */}
            <div className="social-links">
              <a
                href="https://www.instagram.com/trekverse__/"
                className="social-link"
                title="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={22} />
              </a>

              <a
                href="https://in.linkedin.com/company/trekverse-llp"
                className="social-link"
                title="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn size={22} />
              </a>

              <a
                href="mailto:support@trekverse.org"
                className="social-link"
                title="Email"
              >
                <FaEnvelope size={22} />
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section">
            <h4 className="footer-section-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#programs">Programs</a></li>
              <li><a href="#advance">Advance Programs</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Programs Section */}
          <div className="footer-section">
            <h4 className="footer-section-title">Programs</h4>
            <ul className="footer-links">
              <li><a href="#tech">Tech & Data Science</a></li>
              <li><a href="#electronics">Electronics & Embedded</a></li>
              <li><a href="#management">Management</a></li>
              <li><a href="#civil">Civil & Construction</a></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer-section">
            <h4 className="footer-section-title">Get in Touch</h4>
            <div className="contact-info">

              {/* ✅ Upgraded Contact Icons */}
              <div className="contact-item">
                <FaEnvelope size={18} className="contact-icon" />
                <a href="mailto:support@trekverse.org">support@trekverse.org</a>
              </div>

              <div className="contact-item">
                <FaPhoneAlt size={18} className="contact-icon" />
                <a href="tel:6303462806">6303462806</a>
              </div>

            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-text">
            &copy; {currentYear} <span className="highlight">TrekVerse</span>. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span className="divider">•</span>
            <a href="#terms">Terms & Conditions</a>
            <span className="divider">•</span>
            <a href="#cookies">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;